import React, { useEffect, useRef } from 'react';
import { createPortal } from "react-dom";
import { FormattedMessage } from 'react-intl';
import './Modal.css'


function ModalDialog(props: {
    protalId: string
    children: string | JSX.Element | JSX.Element[]
}) {

    let modalContainer = useRef<HTMLDivElement>(null);

    function onMoudWheel(e: Event) {
        e.preventDefault();
    }

    useEffect(() => {
        document.body.addEventListener("mousewheel", onMoudWheel, { passive: false });
        return () => {
            document.body.removeEventListener("mousewheel", onMoudWheel);
        }
    });

    const modalRoot = document.getElementById(props.protalId);
    return createPortal(<div ref={modalContainer}>{props.children}</div>, modalRoot!);
}

export function Modal(props: {
    children: React.ReactNode
    onClick?: () => void
    enable?: boolean,
    titleId?: string
    // tools?: (title: JSX.Element) => JSX.Element
    isMessage?: boolean
}) {
    let modalContainer = useRef<HTMLDivElement>(null);

    if (!props.enable) {
        return (<></>)
    }

    return (
        <ModalDialog protalId={props.isMessage ? "modal-message" : "modal-root"} >
            <div ref={modalContainer} className="modal" role="dialog" onWheel={(e) => {
                e.preventDefault();
            }}>
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable newmodal" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                <FormattedMessage
                                    id={props.titleId ? props.titleId : "empty"}
                                    defaultMessage={props.titleId}
                                    description={props.titleId}
                                />
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.onClick}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {props.children}
                    </div>
                </div>
            </div>
        </ModalDialog >
    )
}

export default function ModalRoot() {
    return (<div id="modal-root" />)

}
export function MessageRoot() {
    return (<div id="modal-message" />)

}

export function ModalFooter(props: {
    children: string | JSX.Element | JSX.Element[]
}) {
    return (
        <div className="modal-footer">
            {props.children}
        </div>
    )
}

export function ModalBody(props: {
    children: string | JSX.Element | JSX.Element[]
}) {
    return (
        <div className="modal-body">
            {props.children}
        </div>
    )
}
